import React, {useState, useEffect, useRef} from "react";
import { DynamicSankeyChart, MetricTabs, NumberCard, PerformerCard } from "../../layouts/ChartLayout";
import { FaTimes } from "react-icons/fa";
import ConversationRecords from "../calls/ConversationRecords.jsx";
import { MdArrowOutward } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import "../../loader.css"
import server from "../../../api/server";
import ModernTimeDropdown from "../../layouts/modernDropdown";
import ModernDateRangePicker from "../../layouts/ModernDateRangePicker";
import CustomerRecords from "../customers/CustomerRecords.jsx";
import { initializeFiltersFromUrl, updateUrlWithFilters, navigateWithFilters } from "../../../utils/filterUtils";

const HomeScreen = ({serviceID, setSelectedMenu, clientID}) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Default filter values
  const defaultFilters = {
          team_name: '',
    time: 'Last 7 Days',
    audioduration: '',
    audioDurationLower: '',
    audioDurationUpper: '',
    recordtype: '',
    customRangeType: 'between',
  };

  // Initialize filters from URL or use defaults
  const initialFilterState = initializeFiltersFromUrl(location, defaultFilters, {});
  
  const [overallMetrics, setOverallMetrics] = useState([])
    const [data] = useState([
            {
              date: '2025-01-01',
              calls: 120,
              agentScore: 6.2,
              needsReview: 15,
              fatalCalls: 3,
              aht: 133,
              topPerformer: 'Vinay',
              bottomPerformer: 'Swati',
              topParameter: "Call Opening",
              bottomParameter: "Product Knowledge",
              fatal: "Yes" // in seconds
            },
            {
              date: '2025-01-15',
              calls: 135,
              agentScore: 6.3,
              needsReview: 14,
              fatalCalls: 2,
              aht: 145,
              topPerformer: 'Vinay',
              bottomPerformer: 'Swati',
              topParameter: "Call Opening",
              bottomParameter: "Product Knowledge",
              fatal: "No"
            },
            {
              date: '2025-02-01',
              calls: 142,
              agentScore: 6.5,
              needsReview: 12,
              fatalCalls: 2,
              aht: 139,
              topPerformer: 'Vinay',
              bottomPerformer: 'Swati',
              topParameter: "Call Opening",
              bottomParameter: "Product Knowledge",
              fatal: "Yes"
            },
            {
              date: '2025-02-15',
              calls: 128,
              agentScore: 6.2,
              needsReview: 16,
              fatalCalls: 4,
              aht: 151,
              topPerformer: 'Vinay',
              bottomPerformer: 'Swati',
              topParameter: "Call Opening",
              bottomParameter: "Product Knowledge",
              fatal: "Yes"
            },
            {
              date: '2025-03-01',
              calls: 138,
              agentScore: 6.4,
              needsReview: 13,
              fatalCalls: 3,
              aht: 140,
              topPerformer: 'Vinay',
              bottomPerformer: 'Swati',
              topParameter: "Call Opening",
              bottomParameter: "Product Knowledge",
              fatal: "No"
            },
            {
              date: '2025-03-15',
              calls: 145,
              agentScore: 6,
              needsReview: 10,
              fatalCalls: 2,
              aht: 133,
              topPerformer: 'Vinay',
              bottomPerformer: 'Swati',
              topParameter: "Call Opening",
              bottomParameter: "Product Knowledge",
              fatal: "Yes"
            }
          ]);
    const [selectedSegment, setSelectedSegment] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [showDetails, setShowDetails] = useState(false)
    const [selectedTab, setSelectedTab] = useState('top_concerns')
    const [service_id, setService_id] = useState(null)
    const [activeMetric, setActiveMetric] = useState(null);
    const [client_id, setClient_id] = useState(null)
    const [email, setEmail] = useState(null)
    const [customStart, setCustomStart] = useState(initialFilterState.customStart)
    const [customEnd, setCustomEnd] = useState(initialFilterState.customEnd)
    const [dispositionData, setDispositionData] = useState(null)
    const [performanceMetrics, setPerformanceMetrics] = useState([])
    // overall legacy loader (not used for UI now)
    const [isLoading, setIsLoading] = useState(false)

    // granular loaders
    const [loadingDisposition, setLoadingDisposition] = useState(false);
    const [loadingPerformanceMetrics, setLoadingPerformanceMetrics] = useState(false);
    const [loadingTopPerformer, setLoadingTopPerformer] = useState(false);
    const [loadingBottomPerformer, setLoadingBottomPerformer] = useState(false);
    const [loadingTopParameter, setLoadingTopParameter] = useState(false);
    const [loadingBottomParameter, setLoadingBottomParameter] = useState(false);
    const [loadingTopConcerns, setLoadingTopConcerns] = useState(false);
    const [loadingTopQueries, setLoadingTopQueries] = useState(false);
    const [overallMetricsLoading, setOverallMetricsLoading] = useState(false);
    const [loadingOverallMetrics, setLoadingOverallMetrics] = useState(false);
    const [topPerformersData, setTopPerformersData] = useState([])
    const [bottomPerformersData, setBottomPerformersData] = useState([])
    const [topParametersData, setTopParametersData] = useState([])
    const [bottomParametersData, setBottomParametersData] = useState([])
    const [topConcernsData, setTopConcernsData] = useState([])
    const [topQueriesData, setTopQueriesData] = useState([])
    const [openConcerns, setOpenConcerns] = useState(null)
    const [openQueries, setOpenQueries] = useState(null)
    const [handledQueries, setHandledQueries] = useState(null)
    const[handledConcerns, setHandledConcerns] = useState(null)
    const [role] = useState(()=> {
      const userCookie = getCookie('dashboard_login_user_creds');
      if (userCookie) {
        const userData = JSON.parse(userCookie);
        const role = userData.role
        return role
      }
      return 'admin';
    })
    const [dummyFilterData, setDummyFilterData] = useState({
        employees: [],
        times: ['Today',
          'Yesterday',
          'This Week',
          "This Month",
          "Last Month",
          "Last 7 Days",
          "Last 30 Days",
          "Last 3 Months",
          "Custom Range"
          ],
        audio_duration: ['Less than 1 Minute', '1-2 Minutes', '3-5 Minutes', 'Above 2 Minutes','More than 5 Minutes', 'Custom Range']
      });
      const [multiSelectFields, setMultiSelectFields] = useState([]);
      const isMultiSelectField = (key) => Array.isArray(multiSelectFields) && multiSelectFields.includes(key);
      const [filters, setFilters] = useState(initialFilterState.filters);
      const metricsDebounceRef = useRef(null);
      const firstMetricsLoadRef = useRef(true);
      const handleQuickFilterChange = (e, key) => {
        const rawValue = e.target.value;
        const value = isMultiSelectField(key)
          ? (Array.isArray(rawValue) ? rawValue : (rawValue ? [rawValue] : []))
          : rawValue;
        if (key === 'time' && !Array.isArray(value) && value !== 'Custom Range') {
          setFilters((prev) => ({ 
            ...prev, 
            [key]: value,
            customRangeType: 'between',
          }));
          setCustomStart(''); 
          setCustomEnd('');
        } else if (key === 'audioduration' && !Array.isArray(value) && value !== 'Custom Range') {
          setFilters((prev) => ({
            ...prev,
            [key]: value,
            audioDurationLower: '',
            audioDurationUpper: '',
          }));
        } else {
          setFilters((prev) => ({ ...prev, [key]: value }));
        }
      };
      const getAudioDurationValueForApi = () => {
        if (filters.audioduration !== 'Custom Range') return filters.audioduration;
        if (filters.audioDurationLower === '' || filters.audioDurationUpper === '') return '';
        const lower = Number(filters.audioDurationLower);
        const upper = Number(filters.audioDurationUpper);
        if (Number.isNaN(lower) || Number.isNaN(upper) || lower < 0 || upper < 0 || lower > upper) return '';
        return `${lower}-${upper}`;
      };
      
      // Update URL whenever filters change - with debouncing and proper conditions
      useEffect(() => {
        // Don't update URL if we're still initializing or if client/service IDs aren't set
        if (!client_id || !service_id) return;
        
        // Debounce URL updates to avoid conflicts with navigation
        const timeoutId = setTimeout(() => {
          updateUrlWithFilters(navigate, location, filters, {}, customStart, customEnd);
        }, 300);
        
        return () => clearTimeout(timeoutId);
      }, [filters, customStart, customEnd, client_id, service_id]); // Removed navigate and location from deps

      const calculatePercentChange = (metric) => {
        const currentValue = data[data.length - 1][metric];
        const previousValue = data[data.length - 2][metric];
        return ((currentValue - previousValue) / previousValue * 100).toFixed(1);
      };
      
      const gotoConcernQuery = () => {
        const queryString = filters.employee || filters.team_name || filters.time !== 'Last 3 Months' || getAudioDurationValueForApi() || filters.recordtype || customStart || customEnd ?
          '?' + new URLSearchParams({
            ...(filters.employee && { employee: filters.employee }),
            ...(filters.team_name && { team_name: filters.team_name }),
            ...(filters.time !== 'Last 3 Months' && { time: filters.time }),
            ...(filters.time === 'Custom Range' && filters.customRangeType && { customRangeType: filters.customRangeType }),
            ...(getAudioDurationValueForApi() && { audioduration: getAudioDurationValueForApi() }),
            ...(filters.recordtype && { recordtype: filters.recordtype }),
            ...(customStart && { customStart }),
            ...(customEnd && { customEnd })
          }).toString() : '';
        navigate(`/${client_id}/${service_id}/concerns-queries${queryString}`);
        setSelectedMenu("Concern Query");
      }
      const gotoAgentFeedback = () => {
        const queryString = filters.employee || filters.team_name || filters.time !== 'Last 3 Months' || getAudioDurationValueForApi() || filters.recordtype || customStart || customEnd ?
          '?' + new URLSearchParams({
            ...(filters.employee && { employee: filters.employee }),
            ...(filters.team_name && { team_name: filters.team_name }),
            ...(filters.time !== 'Last 3 Months' && { time: filters.time }),
            ...(filters.time === 'Custom Range' && filters.customRangeType && { customRangeType: filters.customRangeType }),
            ...(getAudioDurationValueForApi() && { audioduration: getAudioDurationValueForApi() }),
            ...(filters.recordtype && { recordtype: filters.recordtype }),
            ...(customStart && { customStart }),
            ...(customEnd && { customEnd })
          }).toString() : '';
        navigate(`/${client_id}/${service_id}/agent-feedback/overview${queryString}`);
        setSelectedMenu("Agent Feedback Overall");
      }
      const gotoBusinessInsights = () => {
        const queryString = filters.employee || filters.team_name || filters.time !== 'Last 3 Months' || getAudioDurationValueForApi() || filters.recordtype || customStart || customEnd ?
          '?' + new URLSearchParams({
            ...(filters.employee && { employee: filters.employee }),
            ...(filters.team_name && { team_name: filters.team_name }),
            ...(filters.time !== 'Last 3 Months' && { time: filters.time }),
            ...(filters.time === 'Custom Range' && filters.customRangeType && { customRangeType: filters.customRangeType }),
            ...(getAudioDurationValueForApi() && { audioduration: getAudioDurationValueForApi() }),
            ...(filters.recordtype && { recordtype: filters.recordtype }),
            ...(customStart && { customStart }),
            ...(customEnd && { customEnd })
          }).toString() : '';
        navigate(`/${client_id}/${service_id}/customer-insights${queryString}`);
        setSelectedMenu("Customer Insights");
      }
      const transformMetrics = (data) => {
        const lastData = data['last_current_period'];
        const prevData = data['percentage_change']
        return [
            {
              id: 'agentScore',
              title: 'Agent Score',
              value: lastData.agent_score !== null && lastData.agent_score !== '' ? Math.round(lastData.agent_score, 2) : '',
              change: prevData.agent_score===0 ? undefined : prevData.agent_score,
              color: '#10B981',
              allowVisit: false,
              hideBorder: true,
              formatter: (value) => value
            },
          {
              id: 'fatal',
              title: 'Fatal',
              value: lastData.fatal_calls,
              change: prevData.fatal_calls===0 ? undefined : prevData.fatal_calls,
              color: '#4F46E5',
              allowVisit: false,
              hideBorder: true,
              formatter: (value) => value
            },
            {
              id: 'qaHrsSaved',
              title: 'QA Hrs Saved',
              value: Math.round(lastData.qaHrsSaved, 2),
              change: prevData.qaHrsSaved===0 ? undefined : prevData.qaHrsSaved,
              color: '#10B981',
              allowVisit: false,
              hideBorder: true,
              formatter: (value) => value
            },
          {
              id: 'needsReview',
              title: 'Needs Review',
              value: lastData.needs_review,
              change: prevData.needs_review===0 ? undefined : prevData.needs_review,
              color: '#4F46E5',
              allowVisit: false,
              hideBorder: true,
              formatter: (value) => value
            }
        ]
      }

      const transformOverallParameters = (data) => {
        const lastData = data['last_current_period'];
        const prevData = data['percentage_change']
        return [
          {
            id: 'totalCustomers',
            title: '# Total Customers',
            value: lastData.total_customers,
            change: prevData.total_customers===0 ? undefined : prevData.total_customers,
            color: '#4F46E5',
            allowVisit: false,
            hideBorder: true,
            formatter: (value) => value
          },
            {
              id: 'totalCalls',
              title: '# Total Calls',
              value: Math.round(lastData.total_calls, 2),
              change: prevData.total_calls===0 ? undefined : prevData.total_calls,
              color: '#10B981',
              allowVisit: false,
              hideBorder: true,
              formatter: (value) => value
            },
            {
              id: 'fatalCalls',
              title: '#Chats Analyzed',
              value: lastData.chats_analysed,
              change: prevData.chats_analysed === 0 ? undefined : prevData.chats_analysed,
              color: '#EF4444',
              allowVisit: false,
              hideBorder: true,
              formatter: (value) => value
            },
            {
              id: 'aht',
              title: '#Email Analyzed',
              value: 0,
              change: undefined,
              color: '#8B5CF6',
              allowVisit: false,
              hideBorder: true
            },
            {
              id: 'minsAnalyzed',
              title: '#Mins Analyzed',
              value: lastData.total_minutes_analysed,
              change: prevData.total_minutes_analysed === 0 ? undefined : prevData.total_minutes_analysed,
              color: '#F59E0B',
              allowVisit: false,
              hideBorder: true,
              formatter: (value) => value
            }
        ]
      }
      const handleSankeyClick = (data) => {
        let obj = {'name': data}
        obj['type'] = 'business_insights_sankey'
        obj['id'] = 'Business Insight'
        obj['filter_applied'] = {
          ...filters,
          customStart,
          customEnd,
          lastinteraction_range_type: filters.customRangeType || "between",
          'Last Interaction Start': customStart,
          ...(customEnd ? { 'Last Interaction End': customEnd } : {}),
        };
        setSelectedSegment(obj)
        setIsModalOpen(true);
      }

      const getMetrics = () => {
        if(filters.time === 'Custom' && (customStart === '' || customEnd === '')) return;

        // set individual loaders true
        setLoadingDisposition(true);
        setLoadingPerformanceMetrics(true);
        setLoadingTopPerformer(true);
        setLoadingBottomPerformer(true);
        setLoadingTopParameter(true);
        setLoadingBottomParameter(true);
        setLoadingTopConcerns(true);
        setLoadingTopQueries(true);
        setOverallMetricsLoading(true);

        // 1) Disposition Distribution
        server.getDispositionDistribution(client_id, service_id, email, 'home', undefined, null, null, null, null, filters.employee, filters.time, null, customStart, customEnd, null, null, null, filters.team_name)
          .then(async res => {
            if(res.status === 200){
              const json = await res.json();
              if(json.data) setDispositionData(json.data);
            }
          }).finally(()=> setLoadingDisposition(false));

        // 2) Performance Metrics
        server.getPerformanceMetrics(client_id, service_id, email, 'home', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, filters.recordtype, filters.team_name)
          .then(async res => {
            if(res.status === 200){
              const json = await res.json();
              if(json.data){
                setPerformanceMetrics(transformMetrics(json.data));
              }
            }
          }).finally(()=> setLoadingPerformanceMetrics(false));

        // 3) Top Performer
        server.getPerformers(client_id, service_id, email, 'home', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, filters.recordtype, 'DESC', filters.team_name)
          .then(async res => {
            if(res.status === 200){
              const json = await res.json();
              if(json.data) setTopPerformersData([json.data[0]]);
            }
          }).finally(()=> setLoadingTopPerformer(false));

        // 4) Bottom Performer
        server.getPerformers(client_id, service_id, email, 'home', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, filters.recordtype, 'ASC', filters.team_name)
          .then(async res => {
            if(res.status === 200){
              const json = await res.json();
              if(json.data) setBottomPerformersData([json.data[0]]);
            }
          }).finally(()=> setLoadingBottomPerformer(false));

        // 5) Top Parameter
        server.getParameters(client_id, service_id, email, 'home', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, filters.recordtype, 'DESC', filters.team_name)
          .then(async res => {
            if(res.status === 200){
              const json = await res.json();
              if(json.data) setTopParametersData([json.data[0]]);
            }
          }).finally(()=> setLoadingTopParameter(false));

        // 6) Bottom Parameter
        server.getParameters(client_id, service_id, email, 'home', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, filters.recordtype, 'ASC', filters.team_name)
          .then(async res => {
            if(res.status === 200){
              const json = await res.json();
              if(json.data) setBottomParametersData([json.data[0]]);
            }
          }).finally(()=> setLoadingBottomParameter(false));

        // 7) Top Queries
        server.getTopQueries(client_id, service_id, email, 'concerns-queries', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, null, filters.team_name)
          .then(async res => {
            if(res.status === 200){
              const json = await res.json();
              if(json.data){
                let handled=0,total=0;
                json.data.forEach(q=>{handled+=q['Handled Queries'];total+=q['Total Queries'];});
                setOpenQueries({id:'queries',title:'Queries',value:Math.round(total,1),change:null,color:'#10B981',allowVisit:false,hideBorder:true,formatter:v=>v});
                setHandledQueries({id:'%handledQueries',title:'%Handled Queries',value:total?Math.round((handled/total)*100,1):0,change:null,color:'#10B981',allowVisit:false,hideBorder:true,formatter:v=>v});
                setTopQueriesData(json.data);
              }
            }
          }).finally(()=> setLoadingTopQueries(false));

        // 8) Top Concerns
        server.getTopConcerns(client_id, service_id, email, 'concerns-queries', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, null, filters.team_name)
          .then(async res => {
            if(res.status === 200){
              const json = await res.json();
              if(json.data){
                let handled=0,total=0;
                json.data.forEach(c=>{handled+=c['Handled Concerns'];total+=c['Total Concerns'];});
                setOpenConcerns({id:'concerns',title:'Concerns',value:Math.round(total,1),change:null,color:'#10B981',allowVisit:false,hideBorder:true,formatter:v=>v});
                setHandledConcerns({id:'%handledConcerns',title:'%Handled Concerns',value:total?Math.round((handled/total)*100,1):0,change:null,color:'#10B981',allowVisit:false,hideBorder:true,formatter:v=>v});
                setTopConcernsData(json.data);
              }
            }
          }).finally(()=> setLoadingTopConcerns(false));

        // 9) Overall Metrics
        server.getAgentFeedbackOverall(client_id, service_id, email, 'home', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, filters.recordtype, filters.team_name)
          .then(async res => {
            if(res.status === 200){
              const json = await res.json();
              if(json.data){
                setOverallMetrics(transformOverallParameters(json.data));
              }
            }
          }).finally(()=> setOverallMetricsLoading(false));
      }
    
      const handleEndChange = (e) => {
        setCustomEnd(e.target.value);
      };
      const getFilterDetails = async () => {
                  try {
                    let res = await server.getAdvancedFilterDetailsAgentFeedback(client_id, service_id, email, 'concerns-queries', undefined)
                    if(res.status === 200){
                      let resp = await res.json()
                      setMultiSelectFields(Array.isArray(resp.multiselects_list) ? resp.multiselects_list : []);
                      setDummyFilterData(prev => ({
                        ...prev,
                        employees: resp.employee_id,
                        teams: resp.team_names || resp.team_name || resp.teams || []
                    }));
                    }
                  } catch (error) {
                  }
                }
          function getCookie(name) {
                  function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
                  var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
                  return match ? match[1] : null;
          }
          useEffect(() => {
                          const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
                          if (user) {
                            setEmail(user.email);
                          }
                          if(clientID){
                            setClient_id(clientID)
                          }
                          if (serviceID) {
                            setService_id(serviceID);
                          }
                          if(role === 'employee'){
                            handleQuickFilterChange({'target': {'value': user.name}}, 'employee')
                          }
                        }, [serviceID, clientID, role]);
                      
          useEffect(() => {
                          if (client_id && service_id && email) {
                            getMetrics();
                            getFilterDetails();
                          }
                        }, [client_id, service_id, email]);
          useEffect(() => {
            if (!client_id || !service_id || !email) return;
            if (firstMetricsLoadRef.current) {
              firstMetricsLoadRef.current = false;
              return;
            }
            if (metricsDebounceRef.current) {
              clearTimeout(metricsDebounceRef.current);
            }
            metricsDebounceRef.current = setTimeout(() => {
              getMetrics();
            }, 600);
            return () => {
              if (metricsDebounceRef.current) {
                clearTimeout(metricsDebounceRef.current);
              }
            };
          }, [filters, customStart, customEnd, client_id, service_id, email]);
                        useEffect(() => {
                          const handleEsc = (event) => {
                            if (event.key === "Escape") {
                              setShowDetails(false);
                              setIsModalOpen(false);
                            }
                          }
                          if (showDetails || isModalOpen) {
                            window.addEventListener('keydown', handleEsc);
                          }
                          return () => {
                            window.removeEventListener('keydown', handleEsc);
                          }
                        }, [showDetails, isModalOpen])
      
    return (
        <div className="py-3 px-5 font-sans bg-gray-50" style={{height: "100%", overflowY: "scroll"}}>
            <div className='mb-4'>
                <h1 className="text-xl font-semibold text-gray-900 mb-2">Home</h1>
            </div>
            <div className='bg-white rounded-lg shadow-sm p-4 mb-4'>
                <div className="text-sm font-medium text-gray-700 mb-4">Quick Filters</div>
                <div className="flex gap-4 mb-4">
                    <ModernTimeDropdown placeholder="Select Team" value={filters.team_name} onChange={(e) => handleQuickFilterChange(e, 'team_name')} options={dummyFilterData.teams} isMulti={isMultiSelectField('team_name')}/>
                    <ModernTimeDropdown isDisabled={role === 'employee'} placeholder="Select Employee" value={filters.employee} onChange={(e) => handleQuickFilterChange(e, 'employee')} options={dummyFilterData.employees} isMulti={isMultiSelectField('employee')}/>
                    <ModernTimeDropdown placeholder="Select Time Range" value={filters.time} onChange={(e) => handleQuickFilterChange(e, 'time')} options={dummyFilterData.times} isMulti={isMultiSelectField('time')}/>
                    <ModernTimeDropdown placeholder="Select Audio Duration" value={filters.audioduration} onChange={(e) => handleQuickFilterChange(e, 'audioduration')} options={dummyFilterData.audio_duration} isMulti={isMultiSelectField('audioduration')}/>
                    <ModernTimeDropdown placeholder="Select Record Type" value={filters.recordtype} onChange={(e) => handleQuickFilterChange(e, 'recordtype')} options={['call', 'chat']} isMulti={isMultiSelectField('recordtype')}/>
                </div>
          {filters.time === "Custom Range" && (
            <div className="mb-2">
              <ModernDateRangePicker
                startDate={customStart}
                endDate={customEnd}
                rangeType={filters.customRangeType || "between"}
                maxRangeDays={90}
                placeholder="Select Time Range"
                onChange={({ startDate, endDate, rangeType }) => {
                  setCustomStart(startDate);
                  setCustomEnd(endDate);
                  setFilters((prev) => ({ ...prev, customRangeType: rangeType || "between" }));
                }}
              />
            </div>
          )}
          {filters.audioduration === "Custom Range" && (
            <div className="flex gap-4 mb-2">
              <input
                type="number"
                min="0"
                value={filters.audioDurationLower ?? ''}
                onChange={(e) => handleQuickFilterChange(e, 'audioDurationLower')}
                placeholder="Audio Duration Lower Limit (sec)"
                className="px-2 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input"
              />
              <input
                type="number"
                min="0"
                value={filters.audioDurationUpper ?? ''}
                onChange={(e) => handleQuickFilterChange(e, 'audioDurationUpper')}
                placeholder="Audio Duration Upper Limit (sec)"
                className="px-2 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input"
              />
            </div>
          )}
          <div className="flex gap-4 mb-4 flex-wrap">
            {Object.keys(filters).map(
              (key) =>{
                if (key === 'customStart' || key === 'customEnd' || key === 'customRangeType') {
                  return null;
                }
                if (key === 'time' && filters.time === 'Custom Range') {
                  return null;
                }
                if (key === 'audioDurationLower' || key === 'audioDurationUpper') {
                  return null;
                }
                if (key === 'audioduration' && filters.audioduration === 'Custom Range') {
                  return null;
                }
                return (Array.isArray(filters[key]) ? filters[key].length > 0 : filters[key]) && (
                  <div key={key} className="flex items-center bg-indigo-50 p-2 rounded" style={{ fontSize: "0.6rem", lineHeight: "0.25rem" }}>
                    <span className="capitalize text-indigo-600">{key} - {Array.isArray(filters[key]) ? (filters[key].length > 2 ? `${filters[key].slice(0, 2).join(', ')} +${filters[key].length - 2} more` : filters[key].join(', ')) : filters[key]}</span>
                    {key!=='time' && !(role === 'employee' && key === 'employee') && <button
                      className="ml-2 text-gray-600"
                      onClick={() => setFilters((prev) => ({ ...prev, [key]: null }))}
                    >
                      <FaTimes />
                    </button>}
                  </div>
                )
              })}
            {filters.time === "Custom Range" && customStart && (filters.customRangeType === "after" || customEnd) && (
              <div className="flex items-center bg-indigo-50 p-2 rounded" style={{ fontSize: "0.6rem", lineHeight: "0.25rem" }}>
                <span className="text-indigo-600">
                  Time - {customStart} {filters.customRangeType === "after" ? "onwards" : `to ${customEnd}`}
                </span>
                <button
                  className="ml-2 text-gray-600"
                  onClick={() => {
                    setFilters((prev) => ({ ...prev, time: '', customRangeType: 'between' }));
                    setCustomStart('');
                    setCustomEnd('');
                  }}
                >
                  <FaTimes />
                </button>
              </div>
            )}
            {filters.audioduration === "Custom Range" && filters.audioDurationLower !== '' && filters.audioDurationUpper !== '' && (
              <div className="flex items-center bg-indigo-50 p-2 rounded" style={{ fontSize: "0.6rem", lineHeight: "0.25rem" }}>
                <span className="text-indigo-600">Audio Duration - {filters.audioDurationLower} to {filters.audioDurationUpper}</span>
                <button
                  className="ml-2 text-gray-600"
                  onClick={() => setFilters((prev) => ({ ...prev, audioduration: '', audioDurationLower: '', audioDurationUpper: '' }))}
                >
                  <FaTimes />
                </button>
              </div>
            )}
          </div>
        </div>
            <div>
                <div style={{display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", gap: "1rem", padding: "1rem 0"}}>
                    {
                        !overallMetricsLoading && overallMetrics.map((metric, idx) => {
                            return (
                                <div style={{background: "white", borderRadius: "10px"}} className="rounded-xl shadow-sm border"><NumberCard key={idx} metric={metric} activeMetric={activeMetric} 
                                setActiveMetric={setActiveMetric} setShowDetails={setShowDetails} width={"15vw"}/></div>
                            )
                        })
                    }
                </div>
                {
                        overallMetricsLoading && (
                            <div className="flex justify-center items-center bg-white" style={{ height: "88%", flexDirection: "column" }}>
                                <div className="loader"></div>
                                <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                            </div>
                        )
                    }
                <div>
                    {dispositionData && dispositionData.links && dispositionData.links.length > 0 &&<div style={{padding: "10px", borderRadius: "10px", margin: "10px 0", background: "white"}}>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                        <h2 className="text-xl font-semibold">Customer Insights</h2>
                            <div onClick={gotoBusinessInsights} style={{color: "#0000ffa3", cursor: "pointer", display: "flex", alignItems: "center", fontSize: "13px", fontWeight: "500"}}>View Details <MdArrowOutward style={{marginLeft: "5px"}}/></div>
                        </div>
                        <div style={{margin: "10px", background: "white"}}>
                        {
                                loadingDisposition && (
                                    <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                    <div className="loader"></div>
                                    <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                                    </div>
                                )
                                }
                        {!loadingDisposition && <DynamicSankeyChart data={dispositionData} onClickNode={handleSankeyClick}/>}
                        </div>
                    </div>}
                </div>
                <div style={{ margin: "10px 0"}}>
                    <div style={{padding: "10px", borderRadius: "10px", background: "white"}}>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                        <h2 className="text-xl font-semibold">Agent Feedback</h2>
                            <div onClick={gotoAgentFeedback} style={{color: "#0000ffa3", cursor: "pointer", display: "flex", alignItems: "center", fontSize: "13px", fontWeight: "500"}}>View Details <MdArrowOutward style={{marginLeft: "5px"}}/></div>
                        </div>
                        <div style={{display: "flex"}}>
                          <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", width: "44%", gap: "2rem", padding: "1.5rem"}}>
                          {
                                loadingPerformanceMetrics && (
                                    <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                    <div className="loader"></div>
                                    <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                                    </div>
                                )
                                }
                          {
                            !loadingPerformanceMetrics && performanceMetrics.map((metric, idx) => {
                                return (
                                    <div style={{background: "white", borderRadius: "10px"}} className="rounded-xl shadow-sm border"><NumberCard key={idx} metric={metric} activeMetric={activeMetric} 
                                    setActiveMetric={setActiveMetric} setShowDetails={setShowDetails} width={"15vw"}/></div>
                                )
                            })
                          }
                          </div>
                          <div>
                          {
                                loadingTopPerformer && (
                                    <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                    <div className="loader"></div>
                                    <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                                    </div>
                                )
                                }
                          {!loadingTopPerformer && <><div className="py-2 px-3 flex items-center">
                            <div>
                              <PerformerCard title='Top Performer' performers={topPerformersData} colorScheme='top' height={"20vh"} width={"20vw"}/>
                            </div>
                            <div style={{marginLeft: "1rem"}}>
                              <PerformerCard title='Top Parameter' performers={topParametersData} colorScheme='top' height={"20vh"} width={"20vw"}/>
                            </div>
                          </div>
                          <div className="py-2 px-3 flex items-center">
                            <div>
                              <PerformerCard title='Bottom Performer' performers={bottomPerformersData} colorScheme='bottom' height={"20vh"} width={"20vw"}/>
                            </div>
                            <div style={{ marginLeft: "1rem"}}>
                              <PerformerCard title='Bottom Parameter' performers={bottomParametersData} colorScheme='bottom' height={"20vh"} width={"20vw"}/>
                            </div>
                          </div></>}
                          </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div style={{padding: "10px", borderRadius: "10px", margin: "10px 0", background: "white"}}>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                        <h2 className="text-xl font-semibold">Concerns & Queries</h2>
                            <div onClick={gotoConcernQuery} style={{color: "#0000ffa3", cursor: "pointer", display: "flex", alignItems: "center", fontSize: "13px", fontWeight: "500"}}>View Details <MdArrowOutward style={{marginLeft: "5px"}}/></div>
                        </div>
                        <div style={{display: "flex", gap: "30px"}}>
                        {
                          loadingTopConcerns && (
                            <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                              <div className="loader"></div>
                              <div style={{ textAlign: "center" }}>Loading <br /> Please Wait</div>
                            </div>
                          )
                        }
                        {!loadingTopConcerns && <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", width: "40%", gap: "1rem", padding: "1rem"}}>
                        <div style={{background: "white", borderRadius: "10px"}} className="rounded-xl shadow-sm border"><NumberCard metric={openConcerns} activeMetric={activeMetric} 
                                        setActiveMetric={setActiveMetric} setShowDetails={setShowDetails} width={"15vw"}/></div>
                        <div style={{background: "white", borderRadius: "10px"}} className="rounded-xl shadow-sm border"><NumberCard metric={handledConcerns} activeMetric={activeMetric} 
                                        setActiveMetric={setActiveMetric} setShowDetails={setShowDetails} width={"15vw"}/></div>
                        <div style={{background: "white", borderRadius: "10px"}} className="rounded-xl shadow-sm border"><NumberCard metric={openQueries} activeMetric={activeMetric} 
                                        setActiveMetric={setActiveMetric} setShowDetails={setShowDetails} width={"15vw"}/></div>
                        <div style={{background: "white", borderRadius: "10px"}} className="rounded-xl shadow-sm border"><NumberCard metric={handledQueries} activeMetric={activeMetric} 
                                        setActiveMetric={setActiveMetric} setShowDetails={setShowDetails} width={"15vw"}/></div>
                        </div>}
                        <div className="grid grid-cols-1 md:grid-cols-1 gap-6 m-3" style={{width: "60%"}}>
                            <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
                            <div className="px-4 pt-3 border-b border-gray-200 flex items-center">
                                <div onClick={()=>setSelectedTab('top_concerns')} className={`text-md font-medium text-gray-700 mr-2 pb-2 cursor-pointer ${selectedTab === 'top_concerns' && 'border-b border-indigo-700 text-indigo-600 font-bold'}`}>Top Concerns</div>
                                <div onClick={()=>setSelectedTab('top_queries')} className={`text-md font-medium text-gray-700 ml-2 pb-2 cursor-pointer ${selectedTab === 'top_queries' && 'border-b border-indigo-700 text-indigo-600 font-bold'}`}>Top Queries</div>
                            </div>
                            <div className="p-4">
                                <div className="overflow-x-auto overflow-y-auto" style={{height: "25vh"}}>
                                {
                                loadingOverallMetrics && (
                                    <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                    <div className="loader"></div>
                                    <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                                    </div>
                                )
                                }
                                {!loadingOverallMetrics && selectedTab === 'top_concerns' && <table className="min-w-full">
                                    <thead>
                                    <tr className="bg-gray-50 text-left">
                                        <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                                        <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Subcategory</th>
                                        <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right">Total</th>
                                    </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                    {topConcernsData.slice(0, 10).map((concern, index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-sm text-gray-900">{concern['Category']}</td>
                                        <td className="px-4 py-3 text-sm text-gray-900">{concern['Subcategory']}</td>
                                        <td className="px-4 py-3 text-sm text-gray-900 text-right font-medium">{concern['Total Concerns']}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>}
                                {!loadingOverallMetrics && selectedTab === 'top_queries' && <table className="min-w-full">
                                    <thead>
                                    <tr className="bg-gray-50 text-left">
                                        <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                                        <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Subcategory</th>
                                        <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right">Total</th>
                                    </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                    {topQueriesData.slice(0, 10).map((query, index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-sm text-gray-900">{query['Category']}</td>
                                        <td className="px-4 py-3 text-sm text-gray-900">{query['Subcategory']}</td>
                                        <td className="px-4 py-3 text-sm text-gray-900 text-right font-medium">{query['Total Queries']}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>}
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showDetails && (
                    <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "2%", top: "4%", width: "96%", height: "92%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                            zIndex: "999999999", padding: "15px"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>setShowDetails(false)}><FaTimes style={{color: "slategray"}}/></div>
                            <div style={{overflow: "auto", height: "100%"}}>
                              <ConversationRecords serviceID={service_id}/>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                isModalOpen && (
                    <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999", padding: "5px"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>setIsModalOpen(false)}><FaTimes style={{color: "slategray"}}/></div>
                            <div style={{overflow: "auto", height: "100%"}}>
                              <CustomerRecords segment={selectedSegment} serviceID={service_id} type="modal-open" clientID={client_id}/>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default HomeScreen;
